//export const API_KEY = "AIzaSyB2Yno10-YTnLjjn_Vtk0V8cdcY5lC4plU";
//fetch.ai production
//export const API_KEY = "AIzaSyChah5mLygwFFXY-471yi-F2007cknUzhk";

export const API_KEY = process.env.NODE_ENV === 'production'
  ? "AIzaSyChah5mLygwFFXY-471yi-F2007cknUzhk"
  : "AIzaSyB2Yno10-YTnLjjn_Vtk0V8cdcY5lC4plU";